import React from "react";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../../context/LanguageContext";
import { getLabel } from "../../utils/languageUtils";
import ProfileCard from "./ProfileCard";

import FormInput from "../../common/searchconsultant//FormInput";
import SingleSelectField from "../../common/searchconsultant//SingleSelectField";
import MultiSelectField from "../../common/profile/MultiSelectField";

export default function ProfessionalInformationCard({
    data,
    setData,
    errors,
    statuts,
    specialites,
    activityProfs,
    handleChange,
    onAddSpecialite,
    onRemoveSpecialite,
    onAddActivityProf,
    onRemoveActivityProf
}) {

    const { t } = useTranslation();
    const { language } = useLanguage();

    return (

        <ProfileCard
            title={t("monProfile.professionalInformation")}
            icon="bi-briefcase"
        >

            {/* ==================================================
                SITE WEB
            ================================================== */}

            <FormInput
                label={t("monProfile.website")}
                icon="bi-globe"
                type="url"
                name="webSide"
                value={data.webSide || ""}
                onChange={handleChange}
                error={errors.webSide}
            />

            {/* ==================================================
                DATE DEBUT D'ACTIVITE
            ================================================== */}

            <FormInput
                label={t("monProfile.activiteStartDate")}
                icon="bi-calendar-event"
                type="date"
                name="dateStartActv"
                value={data.dateStartActv || ""}
                onChange={handleChange}
                error={errors.dateStartActv}
                max={new Date().toISOString().split("T")[0]}
            />

            {/* ==================================================
                STATUT
            ================================================== */}

            <SingleSelectField
                label={t("monProfile.status")}
                icon="bi-person-badge"
                name="statutId"
                value={data.statutId}
                options={statuts}
                optionValue="id"
                optionLabel={(s) =>
                    getLabel(
                        s,
                        "statut",
                        language
                    )
                }
                onChange={handleChange}
                error={errors.statutId}
            />

            {/* ==================================================
                TYPE D'ACTIVITE
            ================================================== */}

            <SingleSelectField
                label={t("monProfile.activityType")}
                icon="bi-diagram-3"
                name="natureActivityType"
                value={data.natureActivityType}
                onChange={handleChange}
                error={errors.natureActivityType}
                options={[
                    {
                        id: "C",
                        libelle: t(
                            "consultant.types.agriculture"
                        )
                    },
                    {
                        id: "L",
                        libelle: t(
                            "consultant.types.livestock"
                        )
                    }
                ]}
                optionValue="id"
                optionLabel="libelle"
            />

            {/* ==================================================
                ACTIVITES PROFESSIONNELLES
            ================================================== */}

            <MultiSelectField
                key={`activity-${data.natureActivityType}`}
                label={t("menu.activityProf")}
                options={activityProfs}
                value={data.activityProfs || []}
                optionValue="id"
                optionLabel={(a) =>
                    getLabel(
                        a,
                        "activityProf",
                        language
                    )
                }
                onAdd={onAddActivityProf}
                onRemove={onRemoveActivityProf}
                isDisabled={
                    !data.natureActivityType
                }
            />

            {/* ==================================================
                SPECIALITES
            ================================================== */}

            <MultiSelectField
                key={`specialite-${data.natureActivityType}`}
                label={t("menu.speciality")}
                options={specialites}
                value={data.specialites || []}
                optionValue="id"
                optionLabel={(s) =>
                    getLabel(
                        s,
                        "specialite",
                        language
                    )
                }
                onAdd={onAddSpecialite}
                onRemove={onRemoveSpecialite}
                isDisabled={
                    !data.natureActivityType
                }
            />

        </ProfileCard>
    );
}